export const TextBoxMenuIcon = ({ width = 16, height = 16, color = "#1D201E" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width={width} height={height} fill="white" fill-opacity="0.01" />
        <path
            d="M13.125 6.875H15V14.375H16.25V6.875H18.125V5.625H13.125V6.875Z"
            fill={color}
        />
        <path
            d="M12.5 5.625H11.25L10 9.375L8.75 5.625H7.5L9.21875 10L7.5 14.375H8.75L10 10.625L11.25 14.375H12.5L10.7812 10L12.5 5.625Z"
            fill={color}
        />
        <path
            d="M1.875 6.875H3.75V14.375H5V6.875H6.875V5.625H1.875V6.875Z"
            fill={color}
        />
    </svg>
);
